export enum ORDER_HISTORY_ITEM_CHANGE {
    NEW = 1,
    QUANTITY_UPDATED = 2,
    PRICE_UPDATED = 3,
    REMOVED = 4
}